import { render, staticRenderFns } from "./IconChatAlt2Solid.vue?vue&type=template&id=bb2b358c"
import script from "./IconChatAlt2Solid.vue?vue&type=script&lang=js"
export * from "./IconChatAlt2Solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports